import {Medias} from "@/lib/interfaces/medias";

export interface HeaderSettings {
    profile_enabled: boolean
    notifications_enabled: boolean
    theme_switcher_enabled: boolean
    locations_enabled: boolean
}
export interface SocialSettingItem {
    url: string
    name: string
    social_media_icon_svg: string|null
    media: Medias[]
}
export interface SocialSettings {
    children: SocialSettingItem[]
}
export interface FooterSettings {
    footer_text: string|null
    media: Medias[]
}
export interface Settings {
    header: HeaderSettings
    socials: SocialSettings
    footer: FooterSettings
}

export type DateObject = {
    month: string;
    day: string;
    year: string;
};

export function formatDate(dateObj: DateObject): string {
    const months: { [key: string]: string } = {
        'January': '01',
        'February': '02',
        'March': '03',
        'April': '04',
        'May': '05',
        'June': '06',
        'July': '07',
        'August': '08',
        'September': '09',
        'October': '10',
        'November': '11',
        'December': '12'
    };

    const month = months[dateObj.month];
    const day = dateObj.day.length === 1 ? `0${dateObj.day}` : dateObj.day;
    const year = dateObj.year;

    return `${year}-${month}-${day}`;
}
